var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditDialog',{ref:"EditDialog",attrs:{"title":"業務完了解除","displayDeleteButton":false,"hasTitleSuffix":false},on:{"save":_vm.save},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }